import React from 'react'
import FoodListTable from './Components/FoodListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import {HeadingOne} from "Common/Custom/HeadingOne";

const FoodList = () => {
  return (
    <PageBody
     card={true}
     headerchildren={
        <>
        <HeadingOne>Food List</HeadingOne>
        <AddItemBtn url="add-food" title="Create" />
        </>
       }>
  
      {/* Table section */}
      <div className="col-12">
      <FoodListTable/>
      </div>
    </PageBody>
  );
};

export default FoodList;
